import { Component, Input } from '@angular/core';
import { finalize } from 'rxjs';
import { ModalService } from '../../shared/services/modal.service';
import { UsersService } from '../../shared/services/users.service';
import { ZohoCustomerLinksService } from '../../shared/services/zoho-customer-links.service';
import { ValidationService } from '../../shared/services/validation.service';
import { environment } from '../../../environments/environment';
import { Role, UserFormData, ZohoCustomerSettings } from '../../shared/models/user.model';

@Component({
  standalone: false,
  selector: 'app-zoho-customer-link',
  templateUrl: './zoho-customer-link.component.html',
})
export class ZohoCustomerLinkComponent {
  @Input() settings: ZohoCustomerSettings;
  @Input() model: UserFormData;
  @Input() original: UserFormData;
  @Input() parent: UserFormData;
  @Input() showLinks = true;

  removing = false;

  constructor(
    private modal: ModalService,
    private users: UsersService,
    private validation: ValidationService,
    private links: ZohoCustomerLinksService
  ) {}

  removeLink(id: string): void {
    if (this.removing || this.users.authUser?.role !== 'admin') return;
    this.removing = true;
    this.modal
      .confirm(
        'Remove previous Zoho customer link?',
        'This removes the link only from the platform. The customer remains in Zoho. Old invoices can still be downloaded.'
      )
      .open()
      .result.then(confirmed => {
        if (!confirmed) {
          this.removing = false;
          return;
        }
        this.links
          .remove(this.model.id, id)
          .pipe(finalize(() => (this.removing = false)))
          .subscribe({
            next: () => (this.settings.previousZohoContactIds = this.settings.previousZohoContactIds.filter(value => value !== id)),
            error: error => this.validation.handleRequestError(error, 'Users'),
          });
      });
  }

  contactUrl(id: string): string {
    return `https://books.zoho.com/app/${environment.zohoBooksOrganizationId}#/contacts/${encodeURIComponent(id)}`;
  }

  get replacementRequired(): boolean {
    const contactId = this.model?.userRole === Role.DEPUTY ? this.parent?.zohoContactId : this.settings?.zohoContactId || this.model?.zohoContactId;
    return (
      !!(contactId && this.original && this.model) &&
      (this.model.companyName?.trim() !== this.original.companyName?.trim() ||
        this.model.countryCode !== this.original.countryCode ||
        (this.model.vatNumber || '').trim() !== (this.original.vatNumber || '').trim())
    );
  }
}
